import EventEmitter from 'eventemitter3';

const EE = new EventEmitter();

export const eventEmitter = Object.freeze({
  on: (action: string, callback: (...args: any[]) => void) => EE.on(action, callback),
  emit: (action: string, payload: Record<string, unknown>) => EE.emit(action, payload),
  off: (action: string) => EE.off(action),
});
